module.exports = __webpack_public_path__ + "img/product_38.f34cf23.svg";